module.exports = __webpack_public_path__ + "static/icon__crypto--multicolor-163f908a0586a38b43ba4c8bb38ec2c2.png";